import session from './session'

export default {

	/**
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	list_instrumentType() {
		return session.get('lists/instrumentType/')
	},

	/**
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	list_instrument() {
		return session.get('lists/instrument/')
	},

	/**
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	list_project() {
		return session.get('lists/project/')
	},

	list_sample_type() {
		return session.get('lists/sample_type/')
	},

	list_sample() {
		return session.get('lists/sample/')
	},

	list_dye() {
		return session.get('lists/dye/')
	},

	list_treat() {
		return session.get('lists/treat/')
	},

	list_probe() {
		return session.get('lists/probe/')
	},

	/**
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	getCalibrations() {
		return session.get('lists/calibration/')
	},

}